import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageGalleryProps {
  images: string[];
}
export function ImageGallery({
  images
}: ImageGalleryProps) {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const openLightbox = (index: number) => setSelectedIndex(index);
  const closeLightbox = () => setSelectedIndex(null);
  const nextImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex + 1) % images.length);
    }
  };
  const prevImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex - 1 + images.length) % images.length);
    }
  };
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (selectedIndex === null) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') setSelectedIndex((selectedIndex + 1) % images.length);
      if (e.key === 'ArrowLeft') setSelectedIndex((selectedIndex - 1 + images.length) % images.length);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedIndex, images.length]);
  if (!images || images.length === 0) return null;
  return <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-243">
        {images.map((img, idx) => <div key={idx} className="aspect-[4/3] overflow-hidden rounded-sm cursor-pointer group relative" onClick={() => openLightbox(idx)} data-id="element-244">
            <img src={img} alt={`Gallery image ${idx + 1}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-245" />
            <div className="absolute inset-0 bg-club-navy/0 group-hover:bg-club-navy/20 transition-colors duration-300" data-id="element-246"></div>
          </div>)}
      </div>

      <AnimatePresence data-id="element-247">
        {selectedIndex !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-club-navy/95 flex items-center justify-center p-4" onClick={closeLightbox} data-id="element-248">
            <button className="absolute top-6 right-6 text-white hover:text-club-gold transition-colors z-10" onClick={closeLightbox} data-id="element-249">
              <X size={32} data-id="element-250" />
            </button>

            {images.length > 1 && <button className="absolute left-6 top-1/2 -translate-y-1/2 text-white hover:text-club-gold transition-colors z-10 p-2" onClick={prevImage} data-id="element-251">
                <ChevronLeft size={40} data-id="element-252" />
              </button>}

            <motion.img key={selectedIndex} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.2
        }} src={images[selectedIndex]} alt={`Gallery image ${selectedIndex + 1}`} className="max-w-full max-h-[90vh] object-contain rounded-sm" onClick={e => e.stopPropagation()} data-id="element-253" />

            {images.length > 1 && <button className="absolute right-6 top-1/2 -translate-y-1/2 text-white hover:text-club-gold transition-colors z-10 p-2" onClick={nextImage} data-id="element-254">
                <ChevronRight size={40} data-id="element-255" />
              </button>}

            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/70 text-sm" data-id="element-256">
              {selectedIndex + 1} / {images.length}
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}